"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goalSchema = void 0;
const zod_1 = require("zod");
const commonGoal = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    id: zod_1.z.string(),
    finished: zod_1.z.boolean(),
});
const sequenceGoalSchema = commonGoal.merge(zod_1.z.object({
    kind: zod_1.z.literal("sequence"),
    index: zod_1.z.number(),
}));
const parallelGoalSchema = commonGoal.merge(zod_1.z.object({
    kind: zod_1.z.literal("parallel"),
}));
exports.goalSchema = zod_1.z.union([sequenceGoalSchema, parallelGoalSchema]);
//# sourceMappingURL=activity.unstructured.js.map